import NotificationActions from "../actions/NotificationActions";

const initialState = {
  notifications: [],
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NotificationActions.ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            id: new Date().getTime(),
            text: action.payload.text,
            type: action.payload.type,
            linkText: action.payload.linkText,
            linkURL: action.payload.linkURL,
          },
        ],
      };

    case NotificationActions.REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          (not) => not.id !== action.payload.notificationId
        ),
      };

    default:
      return state;
  }
};

export default notificationReducer;
